import { PRICE_MARKUP_TYPE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetPriceMarkupTypes(){
    const api = `${PRICE_MARKUP_TYPE_API}`;
    return axiosHttp.get(api);
}